import React, { useContext } from "react";
import Bluearrow from "../../assests/blueArrow.png";
import goviralLogo23 from "../../assests/goviralLogo23.svg";
import hoeLogo from "../../assests/hoeLogo.png";
import Context from "../../context/Context";

export default function ContactUsFooter({ profileHelpNavigate }) {
  const { buildType } = useContext(Context);
  return (
    <div className="w-[100%] h-[70px] px-[20px] mt-[20px] z-[1] relative">
      <div className="mt-[12px] flex items-center justify-between w-[100%] gap-[10px]">
        <div className="flex items-center">
          <p className="text-small text-[#606060]">To launch a contest,</p>
          <span className="flex items-center justify-center whitespace-nowrap">
            <p
              className="text-small text-[#0F6ABE] ml-[5px] cursor-pointer"
              onClick={profileHelpNavigate}
            >
              contact us
            </p>
            <img src={Bluearrow} alt="" className="w-[4px] h-[8px] ml-[5px]" />
          </span>
        </div>
        <img
          src={buildType == "highonevent" ? hoeLogo : goviralLogo23}
          alt=""
          className="w-[90px]"
        />{" "}
      </div>
    </div>
  );
}
